// extracted by mini-css-extract-plugin
module.exports = {"root":"MessageDetailsForm_root__3wf_u"};